import React from "react";
import BonoboHopeKeyboard from "./BonoboHopeKeyboard";
import "./KeyboardPage.css";

const KeyboardPage = () => {
  return (
    <main className="keyboard-page">
      <section
        className="keyboard-live-section"
        id="live-keyboard"
        aria-labelledby="live-keyboard-title"
      >
        <div className="keyboard-live-section__head">
          <p className="keyboard-eyebrow">Live keyboard</p>
          <h2 id="live-keyboard-title">Select a lexigram to hear it spoken.</h2>
          <p>
            Build an expression in the sentence display, replay it with the
            Period button, and switch between Alpha, Beta, and Delta panels from
            the upper-left controls.
          </p>
        </div>
        <div className="keyboard-live-frame">
          <BonoboHopeKeyboard />
        </div>
      </section>

      <section className="keyboard-instructions" aria-label="Keyboard instructions">
        <article>
          <h2>Using the panels</h2>
          <p>
            Three different panels of lexigrams can be selected from the{" "}
            <i>Alpha</i>, <i>Beta</i>, and <i>Delta</i> symbols at the upper
            left of the keyboard. Adjacent to the panel selection keys is a grey
            sentence display area where your expression is built as you click on
            individual lexigrams. Once your sentence is complete, click on the
            Period button to replay your sentence and clear the sentence
            display.
          </p>
        </article>
        <article>
          <h2>Ultrasonic audio shift</h2>
          <p>
            <b>New Feature:</b> Bonobos almost certainly hear "ultrasonic"
            sounds outside of the human range. To accommodate their
            interpretation of spoken words, this keyboard allows users to
            upshift the audio by up to 3 octaves.
          </p>
          <p>
            Hold down the Alt/Option key while clicking the "2", "3", "4", or
            "5" lexigrams on the Alpha panel to upshift the frequency range. The
            "2" key expands the range by one-half octave, the "3" by one full
            octave, the "4" by two octaves, and the "5" by three octaves. Click
            the "1" lexigram to restore the original sounds.
          </p>
          <p>
            A chirp will play after each octave shift. Safari users will not
            download an ultrasonic version of the 2- and 3-octave shift files;
            audio will be clipped to about 22KHz. Your audio hardware and
            computer configuration may also limit playback to sonic frequencies.
          </p>
        </article>
      </section>

      <section className="keyboard-lexigram-story" aria-label="Lexigram context">
        <p className="keyboard-eyebrow">Lexigrams</p>
        <h2>Abstract symbols for shared reference.</h2>
        <p>
          Lexigrams are abstract symbols used in ape language research. For
          Kanzi and other bonobos, lexigram keyboards created a shared symbolic
          space where objects, actions, requests, places, and ideas could be
          represented.
        </p>
        <h3>What are lexigrams?</h3>
        <p>
          A lexigram is not a picture of an object. It is an arbitrary symbol
          whose meaning is learned through use. That arbitrariness matters
          because it allows researchers to study symbolic understanding rather
          than simple visual matching.
        </p>
        <h3>How Kanzi used lexigrams</h3>
        <p>
          Kanzi used lexigrams to communicate with human partners and to
          participate in a broader symbolic environment. His use of the keyboard
          was connected to spoken English comprehension, shared routines, play,
          requests, and social interaction.
        </p>
      </section>
    </main>
  );
};

export default KeyboardPage;
